import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LoginService } from './../login.service';
import { StringResponse } from '../../Model/Dto/StringResponse';
import { TransferCatalogItem } from '../../Model/Dto/CombineCatalog/TransferCatalogItem';

@Injectable({
  providedIn: 'root'
})
export class CombineCatalogService {
  constructor(private http: HttpClient, public loginService: LoginService) { }

  public referenceItems(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/ReferenceItems", model, options));
  }

  public referenceProducts(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/ReferenceProducts", model, options));
  }

  public moveItems(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/MoveItems", model, options));
  }

  public moveProducts(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/MoveProducts", model, options));
  }

  public copyItems(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/CopyItems", model, options));
  }

  public copyCategories(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/CopyCategories", model, options));
  }

  public copyProducts(model: TransferCatalogItem, startJob: boolean = false): Promise<StringResponse> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("startJob", startJob)
    };
    return lastValueFrom(this.http.post<StringResponse>("api/CombineCatalog/CopyProducts", model, options));
  }
}
